// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.newspopup-dialog-container {
    z-index: 202;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(127, 127, 127, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

div.newspopup-dialog-popup {
    flex: 0 0 75%;
    height: 66%;
    background-color: var(--container-bg-color);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.75);
    display: flex;
    flex-direction: column;
}

div.newspopup-dialog-popup-title {
    font-weight: bold;
    color: var(--titlebar-text-color);
    background-color: var(--titlebar-bg-color);
    flex: 0 0 2.5em;
    display: flex;
    align-items: center;
    padding: 0 0.25em;
    display: flex;
    align-items: center;
}

div.newspopup-dialog-popup-title span:first-child {
    flex: 1 1 auto;
}

div.newspopup-dialog-popup-title span.icon {
    flex: 0 0 auto;
    margin-right: 0.25em;
    font-size: large;
}

div.newspopup-dialog-popup-body {
    padding: 0.25em;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
}

div.newspopup-dialog-popup-body > iframe {
    width: 100%;
    border-width: 0;
    background-color: transparent;
    flex: 1 1 auto;
    height: 0;
}

div.newspopup-dialog-popup-body > div.newspopup-dialog-popup-buttonbar {
    border-top: 1px solid var(--border-color);
    flex: 0 0 auto;
    text-align: center;
}

div.newspopup-dialog-popup-body > div.newspopup-dialog-popup-buttonbar button {
    margin: 0.5em;
    padding: 0.5em;
    background-color: var(--titlebar-bg-color);
    color: white;
    font-weight: bold;
    border: 1px solid var(--border-color);
}

#NewsPopup {
    height: 480px;
}

#NewsPopup div.newspopup-dialog-popup-body {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#NewsPopup div.newspopup-dialog-popup-body > iframe {
    flex: 1 1 auto;
}`, "",{"version":3,"sources":["webpack://./plugins/style/NewsPopup.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,2CAA2C;IAC3C,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,0CAA0C;IAC1C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,0CAA0C;IAC1C,YAAY;IACZ,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB","sourcesContent":["div.newspopup-dialog-container {\n    z-index: 202;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(127, 127, 127, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\ndiv.newspopup-dialog-popup {\n    flex: 0 0 75%;\n    height: 66%;\n    background-color: var(--container-bg-color);\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.75);\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.newspopup-dialog-popup-title {\n    font-weight: bold;\n    color: var(--titlebar-text-color);\n    background-color: var(--titlebar-bg-color);\n    flex: 0 0 2.5em;\n    display: flex;\n    align-items: center;\n    padding: 0 0.25em;\n    display: flex;\n    align-items: center;\n}\n\ndiv.newspopup-dialog-popup-title span:first-child {\n    flex: 1 1 auto;\n}\n\ndiv.newspopup-dialog-popup-title span.icon {\n    flex: 0 0 auto;\n    margin-right: 0.25em;\n    font-size: large;\n}\n\ndiv.newspopup-dialog-popup-body {\n    padding: 0.25em;\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.newspopup-dialog-popup-body > iframe {\n    width: 100%;\n    border-width: 0;\n    background-color: transparent;\n    flex: 1 1 auto;\n    height: 0;\n}\n\ndiv.newspopup-dialog-popup-body > div.newspopup-dialog-popup-buttonbar {\n    border-top: 1px solid var(--border-color);\n    flex: 0 0 auto;\n    text-align: center;\n}\n\ndiv.newspopup-dialog-popup-body > div.newspopup-dialog-popup-buttonbar button {\n    margin: 0.5em;\n    padding: 0.5em;\n    background-color: var(--titlebar-bg-color);\n    color: white;\n    font-weight: bold;\n    border: 1px solid var(--border-color);\n}\n\n#NewsPopup {\n    height: 480px;\n}\n\n#NewsPopup div.newspopup-dialog-popup-body {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n#NewsPopup div.newspopup-dialog-popup-body > iframe {\n    flex: 1 1 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
